<template>
  <div
    class="line-chart"
    :style="{width: width + 'px'}"
  >
    <h2 class="text-black mb-4 mt-3">
      Readership Over Time
    </h2>

    <multi-line-chart
      :timeframe-labels="timeframeLabels || []"
      :items="items"
      :legend-items="legend.items"
      :width="width - 28"
      :height="height"
      :min-width="minWidth"
      :timeframe="timeframe"
    />

    <div
      v-if="legend.items && items"
      class="legend-wrapper"
    >
      <category-legend
        :items="legend.items"
        :items-active="items"
        :client-width="clientWidth"
        :show-na="showNa(Object.keys(items))"
      />
    </div>
  </div>
</template>

<script>
import MultiLineChart from './MultiLineChart'
import CategoryLegend from './CategoryLegend'
import LineChartMixin from '@/analytics/mixins/LineChartMixin'

const props = {
  items: {
    type: Object,
  },
  timeframe: {
    type: String,
    required: false,
    default: 'this_7_days',
  },
  margin: {
    type: Object,
    default: () => ({
      left: 70,
      right: 10,
      top: 10,
      bottom: 60,
    }),
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  minWidth: {
    type: Number,
    required: true,
  },
  clientWidth: {
    type: Number,
    default: null,
  },
  timeframeLabels: {
    type: Array,
    required: false,
  }
}

export default {
  name: 'LineChart',
  mixins: [LineChartMixin],
  components: {
    MultiLineChart,
    CategoryLegend,
  },
  props: props,
  data () {
    return {
      legend: {
        items: {
          'emailClicks': {name: 'Email Clicks', color: '#0e094d'},
          'webViews': {name: 'Web Views', color: '#0364f6'},
          // 'emailReadsNetwork': {name: 'Average Network Email Reads', color: '#58a0e0'},
          'webNetwork': {name: 'Average Network Web Views', color: '#62ddc7'},
          // 'emailReadsNa': {name: 'Email Reads', color: '#8684a6'},
          // 'emailReadsNetworkNa': {name: 'Average Network Email Reads', color: '#abcfef'},
        },
      },
    }
  },
}
</script>

<style lang="scss">
  .line-chart {
    padding: 8px 0 16px 24px;
    border: 1px solid #dfe2ee;
    border-radius: 2px;
    display: inline-block;
    overflow: hidden;
    .legend-wrapper {
      margin: 8px 24px 0 24px;
    }
  }

</style>
